import React, { Component } from 'react';
import TableRow from "@material-ui/core/TableRow";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class AuditsTableItem extends Component {
    constructor(props) {
        super(props);
     
    }


    render() {
        return (


            <TableRow 
                style= {
                    {
                        fontSize: '1rem'
                    }
                }
                key={this.props.audit.id}>
                    <td>
                        <Button
                            style= {
                                {
                                color:'white',
                                backgroundColor: '#002F6C',
                                fontSize: '0.8rem',
                                fontFamily: 'Open Sans'
                                }}
                                onClick={this.props.openDialog.bind(this, this.props.audit)}
                        >
                            {
                                new Date(this.props.audit.created).toLocaleString('en-GB', { timeZone: 'UTC' })
                            }
                        </Button>
                    </td>
                    <td>{this.props.audit.type}</td>
                    <td>{this.props.audit.user}</td>
                    <td>{this.props.audit.summary}</td>
                    <td>{this.props.audit.description.substring(0, 100)+'...'}<a style={{cursor:'pointer'}} onClick={this.props.openDialog.bind(this, this.props.audit)}>see more.</a></td>
            </TableRow>
          
        );
    }
}

export default AuditsTableItem;


// WEBPACK FOOTER //
// ./src/components/AuditsTableItem.js